import React from 'react';
import PropTypes from 'prop-types';
import SimpleModal from 'components/common/modals/SimpleModal';
import formatNumber from 'helpers/formatNumber';
import SimpleAccordion from 'components/common/AccordionToggle/SimpleAccordion';
import './index.scss';

const WalletDetailsModal = ({
  isOpen,
  onClose,
  label,
  data,
  balance,
  organizationName,
}) => {
  return (
    <SimpleModal
      title={`${label} Balance`}
      open={isOpen}
      onClose={onClose}
      contentStyle={{ padding: '0px' }}
    >
      <div className="wallet-modal">
        <div className="wallet-modal__balance">
          <h2>{formatNumber(balance)}</h2>
          <h2 className="wallet-modal__balance__meta">RWF</h2>
        </div>
        <div className="wallet-modal__details">
          {data?.map((wallet, index) => (
            <React.Fragment key={wallet?.label || index}>
              {!wallet?.hasSub && (
                <div
                  className={`wallet-modal__details__item ${
                    wallet?.label === 'Due Commissions'
                      ? 'wallet-modal__details__due'
                      : ''
                  }`}
                >
                  <span className="wallet-modal__details__label">
                    {wallet?.label === 'Float'
                      ? `${organizationName} ${wallet?.label}`
                      : wallet?.label}
                    :
                  </span>
                  <span className="wallet-modal__details__value">
                    {formatNumber(wallet?.value)} RWF
                  </span>
                </div>
              )}
              {wallet?.hasSub && (
                <SimpleAccordion data={wallet} index={index} />
              )}
            </React.Fragment>
          ))}
        </div>
      </div>
    </SimpleModal>
  );
};

WalletDetailsModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  label: PropTypes.string.isRequired,
  data: PropTypes.array.isRequired,
  balance: PropTypes.number.isRequired,
  organizationName: PropTypes.string.isRequired,
};

export default WalletDetailsModal;
